import { Brand } from '@/components/Brand';

/** First run without a .env: say exactly what to set rather than failing silently. */
export function ConfigMissingScreen({ problems }: { problems: string[] }) {
  return (
    <main className="scanlines bg-hud-grid grid h-full place-items-center p-6">
      <div className="cut-tr w-full max-w-lg bg-bg-2/85 p-8 shadow-[inset_0_0_0_1px_var(--color-yellow)]">
        <Brand size="lg" />
        <p className="hud-label mt-8">Setup needed</p>
        <h1 className="mt-2 font-display text-xl font-black tracking-[0.04em] text-yellow uppercase">
          Hive can&apos;t reach the studio database
        </h1>
        <ul className="mt-4 list-disc pl-5 font-mono text-xs text-[#ffc2cd]">
          {problems.map((p) => (
            <li key={p}>{p}</li>
          ))}
        </ul>
        <p className="mt-4 text-muted">
          Copy <code>.env.example</code> to <code>.env</code> at the top of the repo, fill in the hive-dev values, and
          restart <code>npm run dev</code>.
        </p>
      </div>
    </main>
  );
}
